module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.historyList.length != 0) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyFlag),
      expression: "historyFlag"
    }]
  }, _vm._l((_vm.historyList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "history"
    }, [_c('div', {
      staticClass: "form-item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(item[0].reason))])]), _vm._v(" "), (item && item.length == 2) ? _c('div', {
      staticClass: "form-item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("审核说明：")]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(item[1].reason))])]) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "history-func",
    on: {
      "click": function($event) {
        _vm.historyFlag = !_vm.historyFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.historyFlag ? "-- 收起历史记录 --" : "-- 更多历史记录 --"))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-8dcc94a2!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/slider_history.vue
// module id = 774
// module chunks = 1